module.exports = __webpack_public_path__ + "img/cszq_banner_3_mobile.9d5735d0.png";